import { initBotId } from "botid/client/core";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "lenis/dist/lenis.css";
import "@/styles/global.scss";
import { App } from "@/app/App";
import { CONTACT_FORM_ENABLED } from "@/config/site";
import { CONTACT_ENDPOINT } from "@/content/contact";

// The invisible BotID challenge only attaches to the routes declared here, and the server-side
// check fails closed if this list and the function ever disagree. While the form is in stand-by no
// protected request can happen, so the challenge stays out of the page entirely.
if (CONTACT_FORM_ENABLED) initBotId({ protect: [{ path: CONTACT_ENDPOINT, method: "POST" }] });

// GSAP freezes tween time whenever a frame exceeds this threshold, which is meant to avoid a jump
// after a stalled tab. On a phone a single long paint would instead leave the portrait assembly
// stuck half-formed, so the bar is raised: better a brief skip than an animation that hangs.
gsap.ticker.lagSmoothing(1_000, 33);

// Collapsing the iOS toolbar fires a resize with a taller viewport. Refreshing on it re-measures
// every trigger and snaps scroll-driven animations, which reads as a jump while scrolling.
gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

const app = new App();
void app.start();

window.addEventListener("pagehide", () => app.destroy(), { once: true });
